// Estado de la red del propio dispositivo, para la pantalla de sincronización.
//
// Las tablets van por wifi donde lo hay y por datos móviles donde no, y cambiar de una a otra
// a mitad de descarga es justo lo que corta el stream. Con cordova-plugin-network-information
// `navigator.connection.type` dice qué red hay ('wifi', '4g', 'cellular', 'none'…); en un
// navegador normal solo se sabe si hay red o no (navigator.onLine).

function tipo() {
    try {
        let c = (typeof navigator !== 'undefined') ? navigator.connection : null;
        if (c && typeof c.type === 'string' && c.type) {
            let t = c.type.toLowerCase();
            if (t === 'none') return 'ninguna';
            if (t === 'wifi' || t === 'ethernet') return 'wifi';
            if (t === 'unknown') return 'desconocida';
            return 'datos'; // cellular, 2g, 3g, 4g, 5g…
        }
    } catch (e) { /* sin plugin */ }
    if (typeof navigator !== 'undefined' && navigator.onLine === false) return 'ninguna';
    return 'desconocida';
}

function online() {
    return tipo() !== 'ninguna';
}

function etiqueta(t) {
    switch (t || tipo()) {
        case 'wifi': return 'Wi-Fi';
        case 'datos': return 'Datos móviles';
        case 'ninguna': return 'Sin red';
        default: return '';
    }
}

/**
 * Avisa de cada cambio de red con { tipo, anterior, online }. Escucha los eventos
 * online/offline (window y, con Cordova, document) y además sondea el tipo cada pocos
 * segundos, porque pasar de wifi a datos no dispara ninguno de los dos.
 *
 * @returns {Function} función para dejar de vigilar
 */
function vigilar(callback, intervaloMs) {
    let ultimo = tipo();
    function comprobar() {
        let t = tipo();
        if (t === ultimo) return;
        let anterior = ultimo;
        ultimo = t;
        try { callback({ tipo: t, anterior: anterior, online: t !== 'ninguna' }); } catch (e) { console.error(e); }
    }
    window.addEventListener('online', comprobar);
    window.addEventListener('offline', comprobar);
    document.addEventListener('online', comprobar);
    document.addEventListener('offline', comprobar);
    let timer = setInterval(comprobar, intervaloMs || 2000);
    return function parar() {
        window.removeEventListener('online', comprobar);
        window.removeEventListener('offline', comprobar);
        document.removeEventListener('online', comprobar);
        document.removeEventListener('offline', comprobar);
        clearInterval(timer);
    };
}

export default { tipo, online, etiqueta, vigilar };
